module.exports = __webpack_public_path__ + "img/445-6d43ca.png";